import React from 'react';

interface IconProps {
  className?: string;
  'aria-hidden'?: boolean;
}

export const ReviewIcon: React.FC<IconProps> = ({ className, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden={rest['aria-hidden'] ?? true}
  >
    <path
      d="M4 19.5V14.75C4 14.4739 4.22386 14.25 4.5 14.25H9C9.27614 14.25 9.5 14.4739 9.5 14.75C9.5 15.0261 9.27614 15.25 9 15.25H5V19.5C5 19.7761 4.77614 20 4.5 20C4.22386 20 4 19.7761 4 19.5Z"
      fill="currentColor"
    />
    <path
      d="M21 19C21.2761 19 21.5 19.2239 21.5 19.5C21.5 19.7761 21.2761 20 21 20H3C2.72386 20 2.5 19.7761 2.5 19.5C2.5 19.2239 2.72386 19 3 19H21Z"
      fill="currentColor"
    />
    <path
      d="M8.5 19.5V10.25C8.5 9.97386 8.72386 9.75 9 9.75H14.25C14.5261 9.75 14.75 9.97386 14.75 10.25C14.75 10.5261 14.5261 10.75 14.25 10.75H9.5V19.5C9.5 19.7761 9.27614 20 9 20C8.72386 20 8.5 19.7761 8.5 19.5Z"
      fill="currentColor"
    />
    <path
      d="M19 19.5V6.25H14.75V19.5C14.75 19.7761 14.5261 20 14.25 20C13.9739 20 13.75 19.7761 13.75 19.5V5.75C13.75 5.47386 13.9739 5.25 14.25 5.25H19.5C19.7761 5.25 20 5.47386 20 5.75V19.5C20 19.7761 19.7761 20 19.5 20C19.2239 20 19 19.7761 19 19.5Z"
      fill="currentColor"
    />
    <path
      d="M8.375 5.5C8.375 3.91218 7.08782 2.625 5.5 2.625C3.91218 2.625 2.625 3.91218 2.625 5.5C2.625 7.08782 3.91218 8.375 5.5 8.375C7.08782 8.375 8.375 7.08782 8.375 5.5ZM9.375 5.5C9.375 7.6401 7.6401 9.375 5.5 9.375C3.3599 9.375 1.625 7.6401 1.625 5.5C1.625 3.3599 3.3599 1.625 5.5 1.625C7.6401 1.625 9.375 3.3599 9.375 5.5Z"
      fill="currentColor"
    />
    <path
      d="M5 3.53125C5 3.25511 5.22386 3.03125 5.5 3.03125C5.77614 3.03125 6 3.25511 6 3.53125V5H7.46875C7.74489 5 7.96875 5.22386 7.96875 5.5C7.96875 5.77614 7.74489 6 7.46875 6H5.5C5.22386 6 5 5.77614 5 5.5V3.53125Z"
      fill="currentColor"
    />
  </svg>
);
